// Page: MailTemplatesAdmin
// Purpose: Admin wrapper that gates access, shows a spinner during auth check,
// and switches between managing mail templates and the create flow.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/auth';
import Footer from '../../../components/shared/Footer';
import { LoadingSpinner } from '../../../components/ui/feedback/loading-spinner.jsx';
import { isUserAdmin } from '../../../utils/admin/adminUtils';

// Import mail template components
import AdminMailTemplates from './AdminMailTemplates';
import CreateMailTemplate from './CreateMailTemplate';

export default function MailTemplatesAdmin() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [currentView, setCurrentView] = useState('adminMailTemplates');
  
  // Check if user is the admin using the same pattern as other admin pages
  const isAdmin = isUserAdmin(user);

  // Check if user is an admin, if not, redirect to home page
  useEffect(() => {
    if (user) {
      if (!isAdmin) {
        navigate('/app');
      }
      setIsLoading(false);
    } else if (user === null) {
      // No user, redirect to login
      navigate('/login');
    }
  }, [navigate, user, isAdmin]);

  if (isLoading) {
    return (
      <div className="p-6 flex items-center justify-center h-screen">
        <LoadingSpinner message="Loading mail templates admin..." />
      </div>
    );
  }

  if (!isAdmin) {
    return null; // Redirect happens in useEffect
  }

  // Render different views based on current view state
  const renderCurrentView = () => {
    switch (currentView) {
      case 'createMailTemplate':
        return <CreateMailTemplate setCurrentView={setCurrentView} />;
      case 'adminMailTemplates':
      default:
        return <AdminMailTemplates setCurrentView={setCurrentView} />;
    }
  };

  return (
    <div className="min-h-screen">
      {renderCurrentView()}
      <Footer />
    </div>
  );
} 